import RequireDocs from "app/(others)/RequireDocs/RequireDocs";

export default RequireDocs;
